export var PARAM_KEY = 'actions';
export var ADDON_ID = 'storybook/actions';
export var PANEL_ID = "".concat(ADDON_ID, "/panel");
export var EVENT_ID = "".concat(ADDON_ID, "/action-event");
export var CYCLIC_KEY = '$___storybook.isCyclic';